export var MapLayers;
(function (MapLayers) {
    MapLayers["BOUNDARY"] = "Suburb boundary";
    MapLayers["GRAPHICS"] = "Graphics";
    MapLayers["VERY_LOW"] = "1 in 1250 year flood";
    MapLayers["LOW"] = "1 in 500 year flood";
    MapLayers["MEDIUM"] = "1 in 100 year flood";
    MapLayers["HIGH"] = "1 in 20 year flood";
    MapLayers["VERY_HIGH"] = "1 in 20 year flood";
    // This is a blink layer that container the suburb than can be click
    // Call it blink because it will blink upon drag to get user attention
    MapLayers["BLINK"] = "Blink";
})(MapLayers || (MapLayers = {}));
export var FLOOD_RISK;
(function (FLOOD_RISK) {
    FLOOD_RISK["VERY_LOW"] = "very-low";
    FLOOD_RISK["LOW"] = "low";
    FLOOD_RISK["MEDIUM"] = "medium";
    FLOOD_RISK["HIGH"] = "high";
    FLOOD_RISK["VERY_HIGH"] = "very-high";
})(FLOOD_RISK || (FLOOD_RISK = {}));
